import React, { Component } from 'react';
import plus_icon from '../../Images/Daikin_Images/image/Add.png';
import edit_icon from '../../Images/Daikin_Images/image/Edit.png';
import delete_icon from '../../Images/Daikin_Images/image/Delete.png';
import QR_Icon from '../../Images/Daikin_Images/image/QR.png';
import back from '../../Images/Daikin_Images/image/Back.png';

export default class Top_Bar extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	handleRightButton = () => {
		this.props.handleRightButton();
	}

	render() {
		let style = {
			textAlign: 'center',
			width: this.props.width,
			marginBottom: 20,
		}

		// Left element
		let left_button_icon = null;
		if (this.props.left_button_type == 'back') {
			left_button_icon = back;
		}

		let left_elem =
			<div style={{ cursor: 'pointer', width: 45, display: 'inline-block', textAlign: 'left', cursor: 'pointer', verticalAlign: 'top' }} onClick={this.props.handleLeftButton != null ? this.props.handleLeftButton : () => { }}>
				<img src={left_button_icon} style={{ width: 25, marginTop: 10, marginLeft: 10 }} />
			</div>


		let centre_elem =
			<div style={{ width: this.props.width - 90, textAlign: 'center', display: 'inline-block', verticalAlign: 'top', paddingTop: 5 }}>
				<span className="header" style={{ display: 'inline-block', maxWidth: this.props.width - 100, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{this.props.title}</span>
			</div>
		if (this.props.centre_button_type == 'delete') {
			centre_elem =
				<div style={{ width: this.props.width - 90, textAlign: 'center', display: 'inline-block', verticalAlign: 'top', paddingTop: 5 }}>
					<span className="header" style={{ display: 'inline-block', maxWidth: this.props.width - 100, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{this.props.title}</span>
					<img src={delete_icon} style={{ cursor: 'pointer', width: 25, marginTop: 10, marginLeft: 10 }} onClick={this.props.handleCentreButton} />
				</div>
		}

		if (this.props.right_button_type == 'qr') {
			centre_elem =
				<div id='qr' style={{ width: this.props.width - 105, textAlign: 'center', display: 'inline-block', verticalAlign: 'top', paddingTop: 5 }}>
					<span className="header">{this.props.title}</span>
				</div>
		}

		// Right element
		let right_button_icon = null;
		if (this.props.right_button_type == 'add') {
			right_button_icon = plus_icon;
		} else if (this.props.right_button_type == 'edit') {
			right_button_icon = edit_icon;
		} else if (this.props.right_button_type == 'delete') {
			right_button_icon = delete_icon;
		} else if (this.props.right_button_type == 'qr') {
			right_button_icon = QR_Icon;
		}

		let right_elem =
			<div style={{ cursor: 'pointer', display: 'inline-block', width: 45, textAlign: 'right', cursor: 'pointer' }} onClick={this.props.handleRightButton != null ? this.props.handleRightButton : () => { }}>
				<img src={right_button_icon} style={{ width: 25, marginTop: 10, marginRight: 10 }} />
			</div>

		if (this.props.right_button_type == 'qr') {
			right_elem =
				<div style={{ cursor: 'pointer', display: 'inline-block', width: 60, textAlign: 'right', cursor: 'pointer' }} onClick={this.props.handleRightButton != null ? this.props.handleRightButton : () => { }}>
					<img src={right_button_icon} style={{ width: 50, marginTop: 10, marginRight: 10 }} />
				</div>
		}

		return (
			<div style={style} id='top_bar'>
				{left_elem}
				{centre_elem}
				{right_elem}
			</div>
		)
	}
}